// 等待 DOM 加载完成
document.addEventListener('DOMContentLoaded', function() {
    // 获取所有元素（ID 与 HTML 保持一致）
    const oneWrap = document.getElementById('nav-20250723-oneWrap');
    const twoWrap = document.getElementById('nav-20250723-twoWrap');
    const threeWrap = document.getElementById('nav-20250723-threeWrap');
    const fourWrap = document.getElementById('nav-20250723-fourWrap');
    const fiveWrap = document.getElementById('nav-20250723-fiveWrap');
    const sixWrap = document.getElementById('nav-20250723-sixWrap');
    const sevenWrap = document.getElementById('nav-20250723-sevenWrap');
    
    // 通用函数：切换面板显示 + 箭头旋转
    function togglePanelAndArrow(event, panel) {
        event.stopPropagation();
        const isHidden = getComputedStyle(panel).display === 'none';
        // 切换面板显示状态
        panel.style.display = isHidden ? 'flex' : 'none';
        // 切换箭头旋转状态（通过给父元素加类名控制）
        const menuGroup = event.currentTarget.closest('.nav-20250723-menu-group');
        if (menuGroup) {
            menuGroup.classList.toggle('arrow-rotate', isHidden);
        }
    }

    // 各面板切换函数（复用通用逻辑）
    window.nav20250723_toggletwoWrap = function(event) {
        togglePanelAndArrow(event, twoWrap);
    };
    window.nav20250723_togglethreeWrap = function(event) {
        togglePanelAndArrow(event, threeWrap);
    };

    window.nav20250723_toggleFourWrap = function(event) {
        togglePanelAndArrow(event, fourWrap);
    };

    window.nav20250723_toggleFiveWrap = function(event) {
        togglePanelAndArrow(event, fiveWrap);
    };

    window.nav20250723_toggleSixWrap = function(event) {
        togglePanelAndArrow(event, sixWrap);
    };

    window.nav20250723_toggleSevenWrap = function(event) {
        togglePanelAndArrow(event, sevenWrap);
    };

    window.nav20250723_toggleMenu = function(event, targetId) {
        event.stopPropagation();
        const target = document.getElementById(targetId);
        if (!target) return;
        // 调用通用函数
        togglePanelAndArrow(event, target);
    };

    // 点击页面其他区域关闭所有面板并重置箭头
    document.addEventListener('click', function() {
        const allPanels = [oneWrap, twoWrap, threeWrap, fourWrap, fiveWrap, sixWrap, sevenWrap];
        allPanels.forEach(panel => {
            if (panel) panel.style.display = 'none';
        });
        // 移除所有箭头旋转类名
        document.querySelectorAll('.nav-20250723-menu-group').forEach(group => {
            group.classList.remove('arrow-rotate');
        });
    });

    // 阻止菜单内部点击冒泡（点击菜单内容不关闭面板）
    document.querySelector('.nav-20250723-list-wrapper').addEventListener('click', function(event) {
        event.stopPropagation();
    });
});